
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Campaign } from '@/utils/models';
import { DataService } from '@/service/DataService';
import { AgGridVue } from 'ag-grid-vue';
import {
  CellValueChangedEvent,
  GridApi,
  GridOptions,
  GridReadyEvent,
  SelectionChangedEvent,
  SuppressHeaderKeyboardEventParams,
  SuppressKeyboardEventParams,
} from 'ag-grid-community';
import CheckBox from '../../components/utils/CheckBox.vue';
import { v4 as uuid } from 'uuid';
import CheckBoxCellRenderer from '../../components/utils/CheckBoxCellRenderer.vue';
import CheckBoxCellEditor from '../../components/utils/CheckBoxCellEditor.vue';
import TextCellEditor from '../../components/utils/BodyCellEditor.vue';
import CampaignPopup from '../../components/popup/common/CampaignPopup.vue';
@Component({
  components: {
    AgGridVue,
    CheckBox,
    CampaignPopup,
    CheckBoxCellRenderer,
    CheckBoxCellEditor,
    TextCellEditor: TextCellEditor,
  },
})
export default class CampaignView extends Vue {
  private dataService: DataService = this.$store.state.dataService;
  isDialogOpen = false;
  isSending = false;
  inputData = {
    title: '',
    body: '',
    url: '',
    visible: true,
  };

  selectedCampaigns: Campaign[] = [];
  campaignRowData: Campaign[] = this.$store.state.campaigns;
  gridApi: GridApi | null = null;
  gridOptions: GridOptions = {
    rowSelection: 'multiple',
    columnDefs: [
      {
        field: 'title',
        headerName: 'タイトル',
        editable: true,
        headerCheckboxSelection: true,
        checkboxSelection: true,
      },
      {
        field: 'body',
        headerName: '本文',
        editable: true,
        cellEditorPopup: true,
        suppressKeyboardEvent: this.onSuppressKeyboardEvent,
        cellEditor: 'TextCellEditor',
      },
      {
        field: 'url',
        headerName: 'URL',
        editable: true,
      },
      {
        field: 'visible',
        headerName: '表示',
        cellRenderer: 'CheckBoxCellRenderer',
        cellEditor: 'CheckBoxCellEditor',
        cellEditorPopup: true,
      },
    ],
    onCellValueChanged: this.onCellValueChanged,
    onGridReady: this.onGridReady,
    onSelectionChanged: this.onSelectionchange,
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 180,
      editable: true,
    },
  };

  @Watch('$store.state.campaigns')
  onCampaignsChanged() {
    this.gridApi?.setRowData(this.$store.state.campaigns);
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }
  onSelectionchange(event: SelectionChangedEvent) {
    this.selectedCampaigns = event.api.getSelectedRows();
  }

  onSuppressKeyboardEvent(params: SuppressKeyboardEventParams) {
    return params.event.key === 'Enter';
  }

  async onCellValueChanged(event: CellValueChangedEvent) {
    try {
      await this.dataService.emitUpdateCampaign(event.data);
    } catch (error) {
      const message = (error as Error).message;
      console.error(message);
      this.$toast.error(message);
    }
  }

  async onDelete() {
    const campaigns = this.gridApi?.getSelectedRows() as Campaign[];
    try {
      await this.dataService.emitDeleteCampaigns(campaigns);
      this.gridApi?.deselectAll();
    } catch (error) {
      const message = (error as Error).message;
      this.$toast.error(message);
    }
  }
  closeDialog() {
    this.isDialogOpen = false;
    this.inputData = {
      title: '',
      body: '',
      url: '',
      visible: true,
    };
    this.isSending = false;
  }
  openDialog() {
    this.isDialogOpen = true;
  }

  async create() {
    const campaign: Campaign = {
      id: uuid(),
      title: this.inputData.title,
      body: this.inputData.body,
      url: this.inputData.url,
      visible: this.inputData.visible,
    };
    //TODO: バリデーションがテキトーすぎるので修正。
    if (!campaign.title || !campaign.body || !campaign.url) {
      this.$toast.warning('全て入力してください。');
      return;
    }
    try {
      this.isSending = true;
      await this.dataService.emitRegisterCampaign(campaign);
      this.isSending = false;
      this.closeDialog();
    } catch (error) {
      console.error(error);
      this.$toast.warning(error as Error);
    }
  }
  async onCampaignVisibleChange(value: string) {
    if (value.includes('itreview')) {
      const target = (this.$store.state.campaigns as Campaign[]).find((c) => c.id === 'itreview');
      if (target) {
        target.visible = value.includes('visible');
        await this.dataService?.emitUpdateCampaign(target);
      }
    }
  }
}
